import React from 'react';
import { Box, Text, Flex, Button, Image } from 'theme-ui';
import defaultPicture from './images/default.png';
import { FaLinkedin, FaEnvelope, FaInstagram } from 'react-icons/fa';

const SidePanel = ({ user, closePanel }) => {

  if (!user) return null; // Don't render the panel if no user data is passed

  const getRandomColor = (seed) => {
    const hue = Math.abs(seed.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)) % 360;
    return `hsl(${hue}, 70%, 80%)`;
};

  const pictureStyle = {
    width: '130px', 
    height: '130px',
    border: '0.5px solid #6E4884',
    borderRadius: '50%',
    boxShadow: '0 3px 10px rgba(0, 0, 0, 0.2)',
    objectFit: 'cover',
    marginBottom: '15px',
  };
  
  const textContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Poppins',
    alignItems: 'center',
  };
  
  const nameStyle = {
    align: 'center',
    textAlign: 'center',
    color: '#6E4884',
    fontSize: '1.8em',
    margin: '0',
    padding: '0.2em',
  };
  
  const roleStyle = {
    align: 'center',
    textAlign: 'center',
    color: '#6E4884',
    fontSize: '1.15em',
    margin: '0',
    padding: '0.2em',
  };

  const bioStyle = {
    align: 'center',
    color: '#6E4884',
    fontSize: '0.95em',
    margin: '0.7em 0.2em',
    padding: '0.2em 0.5em',
    outline: '0.5px solid #6E4884',
    outlineOffset: '0.5em',
    borderRadius: '10px',
  };

  const generalStyle = {
    align: 'center',
    textAlign: 'center',
    color: '#6E4884',
    fontSize: '0.95em',
    margin: '0.75em 0.2em',
  };

  const iconStyle = {
    align: 'center',
    color: '#6E4884',
    fontSize: '2em',
    padding: '0.2em',
    margin: '0.2em',
    
    '&:hover': {
      color: '#FFFFFF',
      cursor: 'pointer',
    }
    
  };

  const roundedStyle = {
    backgroundColor: '#D5B3E7',
    padding: '0.5em 0.75em',
    fontSize: '0.85em',
    textAlign: 'center',
    borderRadius: '20px',
    margin: '2px',
    boxSizing: 'border-box',
    padding: '2px 8px',
  };

  const roundedStyle2 = (state) => ({
    backgroundColor: getRandomColor(state),
    padding: '0.5em 0.75em',
    fontSize: '0.85em',
    textAlign: 'center',
    borderRadius: '20px',
    margin: '2px',
    boxSizing: 'border-box',
    padding: '2px 8px',
  });

  const flexStyle = {

    flexDirection: 'row', 
    flexWrap: 'wrap', 
    alignItems: 'center', 
    justifyContent: 'center', 
    margin: '0.5em',

  };

  const handleClick = (user, key) => {

    if (key === 'email') {
      window.location.href = `mailto:${user.email}`;
    }

    else if (key === 'linkedin') {
      const linkedinUrl = user.linkedin.startsWith('http') ? user.linkedin : `https://${user.linkedin}`;
      window.open(linkedinUrl, '_blank');
    }

    else if (key === 'instagram') {
      const instagramUrl = user.instagram.startsWith('http') ? user.instagram : `https://instagram.com/${user.instagram.trim()}`;
      window.open(instagramUrl, '_blank');
    }

  };

  return (
    <Box
      sx={{
        position: 'fixed',
        cursor: 'auto',
        top: 0,
        right: 0,
        width: '20%',
        height: '100%',
        bg: 'background',
        overflowY: 'scroll',
        backgroundColor: '#FFFFFF',
        boxShadow: '-2px 0px 10px rgba(0, 0, 0, 0.1)',
        padding: 3,
        zIndex: 1000,
        transition: 'transform 0.3s ease',
      }}
    >
      <Button
        onClick={closePanel}
        sx={{
          position: 'absolute',
          top: '10px',
          left: '10px',
          padding: '5px 10px',
          backgroundColor: '#6E4884',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        x
      </Button>

        <Flex sx={{ flexDirection: 'column', alignItems: 'center' }}>
        <img src={user.photo || defaultPicture}  alt={"Profile picture"} style={pictureStyle} />
        <div style={textContainerStyle}>

          <h1 style={nameStyle}>{user.displayName}</h1>
          <h1 style={roleStyle}>{"Class of " + (user.classYear || "Harvard College")}</h1>
          <h1 style={roleStyle}>
            {Array.isArray(user.concentration) 
              ? user.concentration.join(', ') 
              : (user.concentration || "Student")}
          </h1>

          {user.interests && user.interests.length > 0 && (
            <div>
              <Flex sx={flexStyle}>
                {user.interests.map((interest, index) => (
                  <p key={index} style={roundedStyle}>
                    {interest}
                  </p>
                ))}
              </Flex>
            </div>
          )}


          {user.bio && (
            <p style={bioStyle}>
              {user.bio}
            </p>
          )}

          {user.companies && user.companies.length > 0 && (
            <div>
              <h2 style={generalStyle}>Companies</h2>
              <Flex sx={flexStyle}>
                {user.companies.map((company, index) => (
                  <p key={index} style={roundedStyle}>
                    {company}
                  </p>
                ))}
              </Flex>
            </div>
          )}

          {user.courses && user.courses.length > 0 && (
            <div>
              <h2 style={generalStyle}>Courses Taken</h2>
              <Flex sx={flexStyle}>
                {user.courses.map((course, index) => (
                  <p key={index} style={roundedStyle2 (course)}>
                    {course}
                  </p>
                ))}
              </Flex>
            </div>
          )}

          {user.coursesTaught && user.coursesTaught.length > 0 && (
             <div>
               <h2 style={generalStyle}>Courses Taught</h2>
               <Flex sx={flexStyle}>
                 {user.coursesTaught.map((course, index) => (
                   <p key={index} style={roundedStyle2 (course)}>
                     {course}
                   </p>
                 ))}
               </Flex>
             </div>
           )}

        </div>

        <Flex sx={{ flexDirection: 'row', alignItems: 'center' }}>
              {user.email && (<FaEnvelope style={iconStyle} onClick={() => handleClick(user, 'email')}/>)}
              {user.linkedin && (<FaLinkedin style={iconStyle} onClick={() => handleClick(user, 'linkedin')}/>)}
              {user.instagram && (<FaInstagram style={iconStyle} onClick={() => handleClick(user, 'instagram')}/>)}
        </Flex>

        </Flex>
    </Box>
  );
};

export default SidePanel;
